/* istanbul ignore file */
import { UntypedFormGroup } from '@angular/forms';

import { Field } from '.';
import { DashboardFilter, FilterMenuOptions } from '../../../models';

export class DashboardsFiltersLogicServiceModel {
    static readonly filtersFormMaxHeightPx = 544;
    static readonly filtersFormMinHeightPx = 216;

    dashboardsFiltersForm: UntypedFormGroup = new UntypedFormGroup({});
    appliedFiltersCount: number | null = null;
    availableFields: Field[] = [];
    selectedFields: Field[] = [];
    dashboardFilterMenuOptions: FilterMenuOptions = new FilterMenuOptions();
    currentFilter: DashboardFilter = new DashboardFilter();
    isLoadingValues = false;
    filteredSites?: string[];
}
